module.exports = __webpack_public_path__ + "img/authImg.652f7e8a.jpg";